import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.NXTz74rSOZDpz3_l5jvUygyubDNlTbM8Dn3JqAiF5csyqQ1YHpnjSljt2alpcwwwpFY4bomFT6Uii6BUzBVY7olF9vRqNWMbWhCKEEf0QH0mV3hczKGPuywL3BNsedM71hYfZWN-F9AKjCmbkxndrMxbwT2yxe3ujEl-kxVEBp3y-ABotGbgAcjbP2oyXzQFPuwSDAoPl40ue7G6Exg8yt0qQPLWlSWStZz8g6vSbHfiBE-hOo7pW3S8V1ojXRpG_RnIKS2-WKD14oe1icStL_n7h0gCVr_S_w7N7qG4nZtld-vOKcmnQ1z3Pxnz2vefdy8WgXm0k6qO35dMAwiBS483eDbLp372zA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-06-15T15:23:33.481946Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.NXTz74rSOZDpz3_l5jvUygyubDNlTbM8Dn3JqAiF5csyqQ1YHpnjSljt2alpcwwwpFY4bomFT6Uii6BUzBVY7olF9vRqNWMbWhCKEEf0QH0mV3hczKGPuywL3BNsedM71hYfZWN-F9AKjCmbkxndrMxbwT2yxe3ujEl-kxVEBp3y-ABotGbgAcjbP2oyXzQFPuwSDAoPl40ue7G6Exg8yt0qQPLWlSWStZz8g6vSbHfiBE-hOo7pW3S8V1ojXRpG_RnIKS2-WKD14oe1icStL_n7h0gCVr_S_w7N7qG4nZtld-vOKcmnQ1z3Pxnz2vefdy8WgXm0k6qO35dMAwiBS483eDbLp372zA'

// {
//   "access_token": "v2.local.BCM7gYnP95yP6-00DIH5JXHd-v4qLJdLOwwuuMKzEXqyu0npom5DonE8Tv3xPwGDyBmQakKnWfKBfMhNP8ClcyPgMwwfcBgLMghw4PYJcbGiXH5H-jEpo6VWCxgLM8mUNvz9rW-ZVAAhHeKoPgcHXvXRawpnirffV-ZTUAuPAY2pAGfGAzxHdCfKz04AV-LxLuVzYMUCKLS0tzny5kEOqK5YIKug9_dM51zvMePilH46zvd60_wiWmaA-v-6HUDqlgiRlBsic-5wVYENUBsHxUYdmCVLqJjn6I8DchsPlVYhuNyMJIq8yXnc78xs8lhTsl2RCGuQRWx9FS1Gv-XMdI-Qu0RW",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-06-15T15:23:33.937585Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.BCM7gYnP95yP6-00DIH5JXHd-v4qLJdLOwwuuMKzEXqyu0npom5DonE8Tv3xPwGDyBmQakKnWfKBfMhNP8ClcyPgMwwfcBgLMghw4PYJcbGiXH5H-jEpo6VWCxgLM8mUNvz9rW-ZVAAhHeKoPgcHXvXRawpnirffV-ZTUAuPAY2pAGfGAzxHdCfKz04AV-LxLuVzYMUCKLS0tzny5kEOqK5YIKug9_dM51zvMePilH46zvd60_wiWmaA-v-6HUDqlgiRlBsic-5wVYENUBsHxUYdmCVLqJjn6I8DchsPlVYhuNyMJIq8yXnc78xs8lhTsl2RCGuQRWx9FS1Gv-XMdI-Qu0RW'

// {
//   "access_token": "v2.local.W2memCctIe9Z6GvElly3d-cih1d8zqsNV5LnDc-NycvFWxYlZplo26rRH421YKcbz3lDV7V1YV-hI1JQCN4uQv5aT18anX3MD_d30u_zqIffoDDNsYFipQ2chO6KbGwxkNBijIO-r43IA4FahUgtCGfiOgZfqFIwi8rwW269slYpmXwpqUcs9nqrzchm4oe52HCKO-oznxLz9BlAnco9NLqWdQOV1Ax_0slkfoscu_9ZbiimHBmfLoZewbrqlYDRJIIfa2_Kd_PkEPSuE4srcS3HMQcGUdbsMaqNKuMjaTCrUfCUXFeb36dx1AowfFygja451CxfpktFL82Bso3J9mygc1I",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-06-15T15:23:34.439110Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.W2memCctIe9Z6GvElly3d-cih1d8zqsNV5LnDc-NycvFWxYlZplo26rRH421YKcbz3lDV7V1YV-hI1JQCN4uQv5aT18anX3MD_d30u_zqIffoDDNsYFipQ2chO6KbGwxkNBijIO-r43IA4FahUgtCGfiOgZfqFIwi8rwW269slYpmXwpqUcs9nqrzchm4oe52HCKO-oznxLz9BlAnco9NLqWdQOV1Ax_0slkfoscu_9ZbiimHBmfLoZewbrqlYDRJIIfa2_Kd_PkEPSuE4srcS3HMQcGUdbsMaqNKuMjaTCrUfCUXFeb36dx1AowfFygja451CxfpktFL82Bso3J9mygc1I'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
